module.exports = __webpack_public_path__ + "static/media/_logo.c5f1f93a.png";